import { cn } from "@sylviq/ui-react-web/lib/cn";
import type { HTMLAttributes, ReactNode } from "react";

export type ThemeAppearance = "glass" | "material" | "liquid";

export interface ThemeCanvasProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  appearance?: ThemeAppearance;
}

/** Shared page canvas. Brand stylesheets supply tokens; this owns their use. */
export function ThemeCanvas({
  appearance,
  className,
  children,
  ...props
}: ThemeCanvasProps) {
  return (
    <div
      className={cn("theme-canvas", className)}
      data-appearance={appearance}
      {...props}
    >
      {children}
    </div>
  );
}
